import { WorkspaceScreen } from "../../workspace/components/WorkspaceScreen";
import { ThreadCreate } from "../../thread/components/ThreadCreate";
import styles from "./Home.module.css";

export function HomeScreen() {
  return (
    <WorkspaceScreen>
      <div className={styles.homeContainer}>
        <div className={styles.contentWrapper}>
          <ThreadCreate />
        </div>
      </div>
    </WorkspaceScreen>
  );
}
